/** Health records Maximum ssn failure attempts constant */
export const MAX_SSN_FAILURE_ATTEMPTS = 3;

export const CATAPULT_REPORT = 'Catapult Report';
